import type { ProxyFrameHandle } from '@/components/ProxyFrame/ProxyFrame';
import type { DevicePreset } from '@/types/feedback';

/** The canvas mounts one frame per previewed device, keyed by that device. */
export type CanvasFrameRefs = Partial<
  Record<DevicePreset, ProxyFrameHandle | null>
>;

export const CANVAS_FRAME_HEIGHT = 820;
export const FRAME_GAP_NATIVE = 48;
export const HORIZONTAL_PADDING = 48;
export const PREVIEW_DEVICES: DevicePreset[] = ['mobile', 'desktop'];
export const PRIMARY_DEVICE: DevicePreset = 'desktop';
